import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import SidePanel from '../components/SidePanel';
import CreateNewsModal from '../components/CreateNewsModal';

const AdminNewsPage = () => {
  const [newsEvents, setNewsEvents] = useState([]);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  

  const fetchNewsEvents = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/login');
        return;
      }

      const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/news-events`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setNewsEvents(data.events);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch news events');
        if (response.status === 401) {
          navigate('/login');
        }
      }
    } catch (error) {
      setError('Error fetching news events');
    }
  };

  useEffect(() => {
    fetchNewsEvents();
  }, [navigate]);

  const handleCreate = () => {
    setSelectedEvent(null);
    setIsModalOpen(true);
  };

  const handleEdit = (event) => {
    setSelectedEvent(event);
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/news-events/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      fetchNewsEvents();
    } catch (error) {
      setError('Error deleting news event');
    }
  };

  const handleSave = async (formData) => {
    const token = localStorage.getItem('token');
    const method = selectedEvent ? 'PUT' : 'POST';
    const url = selectedEvent
      ? `${process.env.REACT_APP_BASE_URL_API}/api/news-events/${selectedEvent.id}`
      : `${process.env.REACT_APP_BASE_URL_API}/api/news-events`;

    const body = new FormData();
    body.append('title', formData.title);
    body.append('content', formData.content);
    body.append('categoryId', formData.categoryId);
    body.append('status', formData.status);
    body.append('publishedDate', formData.publishedDate || new Date().toISOString());
    if (formData.headerImage) {
      body.append('images', formData.headerImage);
    }
    if (formData.bodyImages) {
      formData.bodyImages.forEach(image => {
        body.append('images', image);
      });
    }

    try {
      await fetch(url, {
        method,
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body,
      });
      fetchNewsEvents();
      setIsModalOpen(false);
    } catch (error) {
      setError('Error saving news event');
    }
  };

  return (
    <div className="flex h-screen bg-[#f4f7fa]">
      <SidePanel handleLogout={handleLogout} />
      <div className="flex-1 p-10">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-4xl font-bold text-[#364A9A] font-poppins">News</h1>
          <button onClick={handleCreate} className="bg-green-500 text-white font-bold py-2 px-4 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out transform hover:scale-105 font-poppins">
            Create New
          </button>
        </div>
        {error && <p className="text-red-500 text-center mb-4">{error}</p>}
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white">
              <thead>
                <tr>
                  <th className="py-2 px-4 border-b">Title</th>
                  <th className="py-2 px-4 border-b">Category</th>
                  <th className="py-2 px-4 border-b">Status</th>
                  <th className="py-2 px-4 border-b">Published At</th>
                  <th className="py-2 px-4 border-b">Actions</th>
                </tr>
              </thead>
              <tbody>
                {newsEvents.map((event) => (
                  <tr key={event.id}>
                    <td className="py-2 px-4 border-b">{event.title}</td>
                    <td className="py-2 px-4 border-b">{event.category?.name}</td>
                    <td className="py-2 px-4 border-b">{event.status}</td>
                    <td className="py-2 px-4 border-b">{new Date(event.publishedDate).toLocaleString()}</td>
                    <td className="py-2 px-4 border-b">
                      <button onClick={() => handleEdit(event)} className="bg-blue-500 text-white font-bold py-1 px-2 rounded-lg mr-2">
                        Edit
                      </button>
                      <button onClick={() => handleDelete(event.id)} className="bg-red-500 text-white font-bold py-1 px-2 rounded-lg">
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <CreateNewsModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={handleSave} newsEvent={selectedEvent} />
    </div>
  );
};

export default AdminNewsPage;
